var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2021_41972)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2021_41972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.23816 7.98315L5.87104 24.7972",
    stroke: "#333333",
    strokeWidth: 1.52381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37899 16.2016L4.64271 8.09354C5.15309 7.31535 6.993 5.7965 11.2275 6.5678C13.7018 7.01848 15.4705 7.03982 16.7745 6.74546C17.4395 6.59537 17.9777 6.36437 18.4206 6.07632C19.0256 9.00773 19.8889 12.8598 20.3603 14.9237C20.2378 15.0165 20.0679 15.1239 19.8431 15.2349C19.4298 15.439 18.8886 15.6263 18.2574 15.7467C16.9949 15.9873 15.4234 15.9508 13.8534 15.3016C10.7827 14.032 8.01901 15.0809 6.37899 16.2016Z",
    fill: "#496BD3",
    stroke: "#333333",
    strokeWidth: 1.52381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2021_41972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5603 27.592L14.1942 39.6274",
    stroke: "#333333",
    strokeWidth: 1.52381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.968 33.0273L13.7862 27.5082C14.167 27.0048 15.427 26.0288 18.3205 26.5558C20.1341 26.8862 21.453 26.9065 22.4411 26.6834C22.8285 26.596 23.1613 26.4719 23.4494 26.3192C23.8725 28.3499 24.4391 30.8815 24.7724 32.3439C24.7092 32.3842 24.6315 32.4286 24.5374 32.4751C24.2548 32.6146 23.8788 32.7454 23.4361 32.8298C22.5505 32.9986 21.4483 32.9727 20.3483 32.5179C18.1827 31.6225 16.2241 32.2527 14.968 33.0273Z",
    fill: "#496BD3",
    stroke: "#333333",
    strokeWidth: 1.52381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2021_41972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2897 11.6316L26.2946 25.6214",
    stroke: "#333333",
    strokeWidth: 1.52381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0069 18.3747L25.5841 11.7307C26.0212 11.1093 27.5323 9.89668 31.0104 10.5302C33.1113 10.9129 34.6257 10.9336 35.7513 10.6796C36.2576 10.5653 36.6805 10.3963 37.0376 10.1867C37.5404 12.6109 38.2349 15.712 38.6285 17.4366C38.5383 17.4993 38.4204 17.5703 38.2704 17.6444C37.931 17.812 37.4831 17.9673 36.9584 18.0674C35.9089 18.2674 34.6026 18.2369 33.2982 17.6976C30.7405 16.64 28.4329 17.4486 27.0069 18.3747Z",
    fill: "#496BD3",
    stroke: "#333333",
    strokeWidth: 1.52381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.3122 2.35894L19.8525 0.513418",
    stroke: "#496BD3",
    strokeWidth: 1.01587,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2344 4.26893L23.8967 3.30213",
    stroke: "#496BD3",
    strokeWidth: 1.01587,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8197 2.38886L14.9425 0.677603",
    stroke: "#496BD3",
    strokeWidth: 1.01586,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2021_41972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2021_41972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2239,
    height: 20.2239,
    fill: "white",
    transform: "translate(0.934204 5.70532) rotate(-2.9913)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2021_41972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7216,
    height: 14.7216,
    fill: "white",
    transform: "translate(10.6108 25.9336) rotate(-2.9913)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2021_41972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1143,
    height: 17.1143,
    fill: "white",
    transform: "translate(22.1861 9.70361) rotate(-2.9913)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlags);
export default __webpack_public_path__ + "static/media/flags.e09ced982c1a1659784c7b9a6b770849.svg";
export { ForwardRef as ReactComponent };